/** Auth0 custom claim for the Atlas user identifier. */
export const ATLAS_USER_IDENTIFIER_CLAIM = 'https://crossnokaye.com/atlasUserIdentifier';
